import React, { useState } from "react";
import Vimeo from "@u-wave/react-vimeo";

export default function VideoPopUp({ url, setOpenModal, yturl }) {
    return (
        <div
            className="modal fade "
            id="3-year-video"
            data-backdrop="static"
            role="dialog"
        >
            <div className="modal-dialog mt-10">
                <div className="modal-content">
                    <div className="modal-body min-height-90vh">
                        <button
                            type="button"
                            onClick={() => setOpenModal(false)}
                            class="close cross-icon-video-popup"
                            data-dismiss="modal"
                        >
                            &times;
                        </button>
                        <div className="schedule-popup p-1">
                            {/* <Vimeo
                                muted={true}
                                autoplay={false}

                                // className="popover-video"
                                // width={innerWidthHandler()}
                                // height={'100%'}
                                // width={'100%'}
                                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}

                                video={"https://player.vimeo.com/video/1080722547?h=40b8116c4d&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"}
                            /> */}
                            <div>
                                {url == 1 ? (
                                    <iframe
                                        src="https://player.vimeo.com/video/1080722547?h=40b8116c4d&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                        frameborder="0"
                                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                        }}
                                        title="3rd Anniversary for VerySoul video"
                                    ></iframe>
                                ) : (
                                    <iframe
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                        }}
                                        src={yturl}
                                        title="YouTube video player"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerpolicy="strict-origin-when-cross-origin"
                                        allowfullscreen
                                    ></iframe>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
